const TOKEN_ERROR_MESSAGE = {
  INVALID_TOKEN: 'Código inválido',
  LIMIT_OF_ATTEMPTS_EXCEEDED: 4,
  MESSAGE_OF_ATTEMPTS_EXCEEDED:
    'Limite de tentativas excedido. Solicite novamente o re-envio do código.'
};

export default TOKEN_ERROR_MESSAGE;
